'use strict';

function waitForBazaarVoiceElement(selector, callback) {
    // If the element is already there
    const existing = document.querySelector(selector);
    if (existing) {
        callback(existing);
        return;
    }

    // Wait for changes in the DOM
    const observer = new MutationObserver(() => {
        const el = document.querySelector(selector);
        if (el) {
            callback(el);
            observer.disconnect();
        }
    });

    if (document.querySelector('.cc-pdp.product-wrapper')) {
        observer.observe(document.querySelector('.cc-pdp.product-wrapper'), {
            childList: true,
            subtree: true
        });
    }
}

/**
 * Get the footnote marker from attribute.
 * @returns {string} footnote marker
 */
function getBazaarVoiceFootnoteMarker() {
    const footNoteMarkerElement = document.querySelector('[data-bv-footnote-marker]');

    if (footNoteMarkerElement) {
        return footNoteMarkerElement.getAttribute('data-bv-footnote-marker');
    }
}

const init = () => {
    waitForBazaarVoiceElement('.bv_numReviews_component_container', function (el) {
        if (el.querySelector('sup')) return;

        if (el) {
            el.insertAdjacentHTML('beforeend', `<sup>${getBazaarVoiceFootnoteMarker()}</sup>`);
        }
    });
}

init();

module.exports = {
    init: init,

    initWaitForBazaarVoiceElementEvent: function() {
        $('body').on('pdp:triggerWaitForBazaarVoiceElement', function () {
            waitForBazaarVoiceElement('.bv_numReviews_component_container', function (el) {
                if (el.querySelector('sup')) return;

                if (el) {
                    el.insertAdjacentHTML('beforeend', `<sup>${getBazaarVoiceFootnoteMarker()}</sup>`);
                }
            });
        });
    }
};